import "@/App.css";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { useLenis } from "@/hooks/useLenis";
import { initAnalytics } from "@/lib/analytics";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { DemoCta } from "@/components/site/DemoCta";
import { Benefits } from "@/components/site/Benefits";
import { Solutions } from "@/components/site/Solutions";
import { GivingDevice } from "@/components/site/GivingDevice";
import { SeeItInAction } from "@/components/site/SeeItInAction";
import { WhyKonek } from "@/components/site/WhyKonek";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Packages } from "@/components/site/Packages";
import { MonthlySupport } from "@/components/site/MonthlySupport";
import { HumanTrust } from "@/components/site/HumanTrust";
import { ConsultationForm } from "@/components/site/ConsultationForm";
import { FAQ } from "@/components/site/FAQ";
import { FinalCTA } from "@/components/site/FinalCTA";
import { Footer } from "@/components/site/Footer";
import { SocialProof } from "@/components/site/SocialProof";
import { ChatWidget } from "@/components/site/ChatWidget";

function App() {
  useLenis();
  useEffect(() => { initAnalytics(); }, []);
  return (
    <div className="App bg-white min-h-screen antialiased">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:rounded-lg focus:bg-navy-900 focus:px-4 focus:py-2 focus:text-white"
      >
        Skip to content
      </a>
      <Navbar />
      <main id="main">
        <Hero />
        <DemoCta />
        <Benefits />
        <SeeItInAction />
        <GivingDevice />
        <Solutions />
        <HowItWorks />
        <Packages />
        <MonthlySupport />
        <WhyKonek />
        <HumanTrust />
        <FAQ />
        <FinalCTA />
        <ConsultationForm />
      </main>
      <Footer />
      <SocialProof />
      <ChatWidget />
      <Toaster position="top-center" richColors offset="96px" mobileOffset="96px" />
    </div>
  );
}

export default App;
